var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFaceSadCrySolid1({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_1524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.375 48.1836C31.4844 49.3555 28.3105 50 25 50C21.6895 50 18.5156 49.3555 15.625 48.1836V28.125C15.625 27.2656 14.9219 26.5625 14.0625 26.5625C13.2031 26.5625 12.5 27.2656 12.5 28.125V46.6602C5.0293 42.334 0 34.2578 0 25C0 11.1914 11.1914 0 25 0C38.8086 0 50 11.1914 50 25C50 34.2578 44.9707 42.334 37.5 46.6602V28.125C37.5 27.2656 36.7969 26.5625 35.9375 26.5625C35.0781 26.5625 34.375 27.2656 34.375 28.125V48.1836ZM19.0625 22.8125C19.5801 23.5059 20.5566 23.6426 21.25 23.125C21.9434 22.6074 22.0801 21.6309 21.5625 20.9375C18.5938 16.9824 12.6562 16.9824 9.6875 20.9375C9.16992 21.6309 9.30664 22.6074 10 23.125C10.6934 23.6426 11.6699 23.5059 12.1875 22.8125C13.9062 20.5176 17.3438 20.5176 19.0625 22.8125ZM30.9375 22.8125C32.6562 20.5176 36.0938 20.5176 37.8125 22.8125C38.3301 23.5059 39.3066 23.6426 40 23.125C40.6934 22.6074 40.8301 21.6309 40.3125 20.9375C37.3438 16.9824 31.4063 16.9824 28.4375 20.9375C27.9199 21.6309 28.0566 22.6074 28.75 23.125C29.4434 23.6426 30.4199 23.5059 30.9375 22.8125ZM20.3125 32.8125V35.9375C20.3125 38.5254 22.4121 40.625 25 40.625C27.5879 40.625 29.6875 38.5254 29.6875 35.9375V32.8125C29.6875 30.2246 27.5879 28.125 25 28.125C22.4121 28.125 20.3125 30.2246 20.3125 32.8125Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_1524"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaceSadCrySolid1);
export default __webpack_public_path__ + "static/media/face-sad-cry-solid 1.0a577467d52006036987a5b7199f2ea8.svg";
export { ForwardRef as ReactComponent };